// Defense in depth: nothing from 1001tracklists may ever render in the app —
// no link, no artwork. The server scrubs these too; this is the client's own
// guarantee, applied where a server URL reaches an <img> (CoverArt /
// coverUrl) and where external links are built (ArtistLinksRow).

const BLOCKED_HOST_SUFFIX = '1001tracklists.com';

// True when the URL's host is 1001tracklists.com or any subdomain of it
// (cdn.1001tracklists.com, img.1001tracklists.com, ...). Non-URLs → false.
export function isFirstPartyUrlBlocked(url) {
    if (typeof url !== 'string' || !url) return false;
    let host = '';
    try {
        host = new URL(url.trim()).hostname.toLowerCase();
    } catch {
        // Not an absolute URL (local path, data:) — fall back to a text
        // check so a protocol-relative "//cdn.1001tracklists.com/x" is
        // still caught.
        const m = url.match(/^\s*(?:[a-z][a-z0-9+.-]*:)?\/\/([^/?#]+)/i);
        host = m ? m[1].toLowerCase() : '';
    }
    if (!host) return false;
    return host === BLOCKED_HOST_SUFFIX || host.endsWith(`.${BLOCKED_HOST_SUFFIX}`);
}

// Artwork URL passthrough that drops blocked hosts (→ null).
export function safeArtwork(url) {
    return isFirstPartyUrlBlocked(url) ? null : (url ?? null);
}
